import React, { useCallback, useEffect, useState } from "react";

import { getUserSettings, updateProfile } from "services";

import { incompleteMessage, useCancelAsyncOnUnmount, useNavigate, useToggleNavs, useTranslation } from "utils";

import { Button, Col, ErrorBoundary, Form, Link, MainPage, NavigationHeader, Row, Typography, Message as message } from "components";

import { ProfileUpdateHidden } from "pages/app/user/components/ProfileUpdateHidden";
import { ProfileUpdatePublic } from "pages/app/user/components/ProfileUpdatePublic.tsx";

export const ProfileUpdate = () => {
  const { t } = useTranslation(["user", "meta"]);
  useToggleNavs(false, false);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [details, setDetails] = useState({});
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageURL, setImageURL] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadUserSettings = useCallback(() => {
    setLoading(true);

    getUserSettings({
      signal,
    })
      .then((res) => {
        let image = false;
        let imageSuccess = false;

        if (res.image && res.image !== "false") {
          image = res.image;
          imageSuccess = true;
        }
        setImageURL(image);
        setImageSuccess(imageSuccess);
        setDetails(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const complete = (v) => {
    setSaving(true);

    updateProfile({
      ...v,
      ...{ image: imageURL, signal },
    })
      .then(() => {
        navigate("/user");
        message({ content: t("profileUpdate.saved"), icon: "tick" });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  useEffect(() => {
    loadUserSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      <NavigationHeader title={t("profileUpdate.headerTitle")} />
      <Form name="profile" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
        <Row>
          <Col>
            <Typography variant="h1">{t("profileUpdate.title")}</Typography>
          </Col>
        </Row>
        <Row>
          <Col>
            <Typography variant="paragraph-m" style={{ maxWidth: "768px" }}>
              {t("profileUpdate.description")}
            </Typography>
          </Col>
        </Row>
        <ErrorBoundary>
          <ProfileUpdatePublic
            details={details}
            imageSuccess={imageSuccess}
            imageURL={imageURL}
            setImageSuccess={setImageSuccess}
            setImageURL={setImageURL}
            t={t}
          />
        </ErrorBoundary>
        <ErrorBoundary>
          <ProfileUpdateHidden details={details} t={t} />
        </ErrorBoundary>
        <Row className="margin-top-300">
          <Col sm={0} md={3} />
          <Col sm={24} md={18} className="center">
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={loading || saving} loading={loading || saving}>
                {t("profileUpdate.button")}
              </Button>
            </Form.Item>
          </Col>
          <Col sm={0} md={3} />
        </Row>
        <Row>
          <Col sm={0} md={3} />
          <Col sm={24} md={18} className="center">
            <Link to="/user">{t("profileUpdate.cancel")}</Link>
          </Col>
          <Col sm={0} md={3} />
        </Row>
      </Form>
    </MainPage>
  );
};
